module.exports = __webpack_public_path__ + "static/media/4_1.d35406b9.png";